import React from 'react';
import { siteContent } from '../content/siteContent';

const Home = () => {
  const { hero } = siteContent;

  return (
    <section id="hero" className="home" aria-labelledby="hero-heading">
      <div className="container hero-layout">
        <div className="hero-copy">
          <h1 id="hero-heading">{hero.heading}</h1>
          <p className="hero-support">{hero.message}</p>
          <a href={hero.ctaHref} className="btn btn--primary">{hero.ctaLabel}</a>
        </div>

      </div>
    </section>
  );
};

export default Home;
